import { useMemo as o } from "react";
import { getPaymentProcessorPaymentButton as t } from "./get-payment-processor-payment-button.mjs";
import { getPaymentProcessorDetails as m } from "./get-payment-processor-details.mjs";
import { useOfferStore as s } from "../store/index.mjs";
import { getPaymentProcessorProvider as P } from "./get-payment-processor-provider.mjs";
const p = (r) => {
  const { paymentMethod: e } = s();
  return {
    PaymentProcessorProvider: o(
      () => P(e),
      [e]
    ),
    paymentProcessorDetails: m(e, r),
    paymentProcessorPaymentButton: t(e, r)
  };
};
export {
  p as usePaymentProcessors
};
